import { render, staticRenderFns } from "./tcdetail.vue?vue&type=template&id=1c5594bc&scoped=true&"
import script from "./tcdetail.vue?vue&type=script&lang=js&"
export * from "./tcdetail.vue?vue&type=script&lang=js&"
import style0 from "./tcdetail.vue?vue&type=style&index=0&id=1c5594bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5594bc",
  null
  
)

export default component.exports